import React from 'react'
import Typography from "@material-ui/core/Typography";

const getTotalState = (records) => {
    let total = 0;
    let empty = 0;

    records.forEach(record => {
        for (let reception in record.receptions) {
            total = total + record.receptions[reception].total;
            empty = empty + record.receptions[reception].empty;
        }
    });

    return {
        total: total,
        empty: empty
    }
};

const TotalState = (props) => {
    let state = getTotalState(props.records);

    if (!!state) {
        return (
            <Typography variant="subheading" style={{margin: 10, marginLeft: '5%'}}>
                <span style={{fontWeight: 600, color: props.setColor(state.empty/state.total)}}>
                    {'свободно записей: ' + state.empty + ' из ' + state.total}
                </span>
            </Typography>
        )
    } else {
        return null
    }
};

export default TotalState;